'use strict';
import { guuid, isNeArray, isString } from '@aretheyhappy/utils';
import DomUtils from '../util/DomUtils';
//  Append version nr to urls loaded through here
const cacheBust = src => {
    if (src.substr(0, 1) !== '/')
        return src;
    return `${src}?v=${guuid()}`;
};
function endsWith(str, suffix) {
    if (!isString(str) || !isString(suffix))
        return false;
    return str.indexOf(suffix, str.length - suffix.length) !== -1;
}
let AssetsHandler = null;
class Assets {
    constructor() {
        if (AssetsHandler)
            return AssetsHandler;
        this.store = new Map();
    }
    async boot(options) {
        if (this.is_ready)
            return;
        //  Register all the provided assets
        if (isNeArray(options)) {
            options.forEach(el => this.register(el));
        }
        this.is_ready = true;
    }
    get(key) {
        return this.store.get(key) || false;
    }
    patch(key, obj) {
        const o = this.get(key);
        if (!o)
            return;
        return this.store.set(key, Object.assign(o, obj));
    }
    //  Translate the provided key
    async load(key) {
        if (!this.store.has(key))
            throw new Error('Please register asset before calling load', key);
        const asset = this.store.get(key);
        //  If asset is already loaded, return asset payload if json, otherwise return true
        if (asset.is_loaded) {
            return asset.type === 'json' ? asset.payload : true;
        }
        //  Set is_loaded on asset to true to ensure we don't double load
        asset.is_loaded = true;
        this.store.set(key, asset);
        //  Load asset
        if (asset.type === 'json') {
            let data = {};
            //  Fetch asset
            await fetch(cacheBust(asset.src))
                .then(resp => {
                if (resp.ok)
                    return resp.json();
                return new Promise(resolve => resolve({}));
            })
                //  Network errors and unresolvable urls reject, treat them like a failed response
                .catch(() => ({}))
                .then((val = {}) => data = val);
            //  Append payload to asset
            asset.payload = data;
            this.store.set(key, asset);
            //  Execute after if provided
            if (asset.after)
                asset.after(asset.payload);
            return asset.payload;
        }
        else if (asset.type === 'lib' || asset.type === 'app') {
            //  Check if there's a requires statement on the entry
            if (asset.requires) {
                for (const requirement of asset.requires) {
                    await this.load(requirement);
                }
            }
            //  Loop over src files and inject them one by one
            for (const el of asset.src) {
                //  Cache bust src
                const src = cacheBust(el);
                if (endsWith(el, '.css')) {
                    await DomUtils.loadStyle(src);
                }
                else if (endsWith(el, '.js')) {
                    await DomUtils.loadScript(src);
                }
            }
            //  Execute after if provided
            if (asset.after)
                asset.after();
            return true;
        }
    }
    register(obj, load_immediately = false) {
        if (!(obj || {}).key || this.store.has(obj.key))
            throw new Error('Asset already registered', obj);
        this.store.set(obj.key, Object.assign({ is_loaded: false }, obj));
        //  If load immediately is passed, immediately load asset
        if (load_immediately)
            this.load(obj.key);
    }
    tplJSON(key, src, after = false, requires = false) {
        return { key, type: 'json', src, after, requires };
    }
    tplLib(key, src, after = false, requires = false) {
        return { key, type: 'lib', src, after, requires };
    }
}
AssetsHandler = new Assets();
export { AssetsHandler };
export default AssetsHandler;
//# sourceMappingURL=Assets.js.map